import { render, staticRenderFns } from "./alert.template.vue?vue&type=template&id=22454617&scoped=true&"
var script = {}
import style0 from "./alert.template.vue?vue&type=style&index=0&id=22454617&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22454617",
  null
  
)

export default component.exports